<template>
  <div>
    <section class="home-section-1">
      <h2 class="text-center">Growing Up With Undiagnosed ADHD</h2>

      <div class="home-adhd-1 container">
        <p>
          For many people,
          <router-link to="/what-is-adhd"
            >attention-deficit/hyperactivity disorder (ADHD)</router-link
          >
          means years of misunderstanding and a diagnosis that comes later in
          life. Paris knows this firsthand, which inspired her advocacy and
          commitment to redefining how ADHD is understood.
        </p>

        <p>
          “For years, I searched for answers to why things felt harder for me. I
          struggled to complete simple tasks, daydreamed in school, forgot
          things constantly, or felt like I was ‘too much.’ I internalized it
          for&nbsp;years.”
        </p>

        <p class="text-center">
          Her diagnosis helped her better understand experiences she had long carried without explanation, such as struggling with focus and attention. It also marked the beginning of seeing ADHD through a new lens.
        </p>
      </div>
    </section>

    <section class="home-section-2">
      <div class="container">
        <div class="home-section-2-image">
          <img class="d-none d-md-block" :src="section2Image" alt="" />
          <img class="d-block d-md-none" :src="section2ImageS" alt="" />
        </div>

        <h2 class="text-center">
          A Different Look at ADHD
        </h2>

        <p>
          Paris began to see ADHD as more than a limitation, recognizing the
          creativity and perspective it can bring. While embracing ADHD helped
          Paris understand herself, she still needed support managing the
          symptoms that came with it.
        </p>

        <p>
          “I’ve learned to look at ADHD from a different perspective,” said
          Paris Hilton. “‘Embrace Your Sparkle’ reminds me that ADHD can be a
          source of creativity and courage. But the real-life daily challenges
          of ADHD symptoms can be overwhelming, and I know so many people can
          relate to&nbsp;that.”
        </p>

        <p>
          As Paris entered her favorite era yet, being both a mom and an
          entrepreneur, she found that this new chapter in life came with new
          challenges in managing her ADHD symptoms. So, she decided to talk with
          her doctor about a treatment that could work for her.
        </p>
      </div>
    </section>

    <section class="home-section-3">
      <div class="container">
        <h2 class="text-center">
          Paris’ ADHD Symptom Management Experience With JORNAY PM<sup>®</sup>
        </h2>

        <p class="text-center mx-auto">
          For Paris, focusing was most challenging at the start of her day. Mornings felt overwhelming, leaving her feeling behind before the day even began. She knew she needed a treatment that could help manage her symptoms from the moment she woke up, through her packed schedule, and into the early evening.
        </p>
      </div>

      <div class="home-section-3-image">
        <div class="home-section-3-text">
          <p>
            “I love that JORNAY PM is taken at night, so I don’t have to worry
            about taking my medication during my already hectic morning routine.
            For me, it means that when my day begins, my ADHD symptoms are
            already being managed.”
          </p>
        </div>

        <img class="d-none d-lg-block" :src="section3Image" alt="" />
        <img class="d-block d-lg-none" :src="section3ImageS" alt="" />
      </div>

    <div class="container">
      <p class="stimulant text-center">JORNAY PM is a stimulant prescription medicine used to treat ADHD in people 6 years of age and older. It&nbsp;may help increase attention and decrease impulsiveness and hyperactivity. JORNAY PM is not recommended for use in children under 6 years of&nbsp;age.</p>
    </div>

    </section>
  </div>
</template>

<script>
import section2Image from "../../assets/images/3_25/home/paris-hilton-2025.webp";
import section2ImageS from "../../assets/images/3_25/home/paris-hilton-2025-s.webp";
import section3Image from "../../assets/images/3_25/home/paris-hilton-2025-2.webp";
import section3ImageS from "../../assets/images/3_25/home/paris-hilton-2025-2-s.webp";

export default {
  name: "Journey",
  data() {
    return {
      items: [
        {
          image: require("../../assets/images/3_25/home/NightDosing.svg"),
          caption: "Taken at night to <br>tackle tomorrow",
          alt: "Blue graphic of a crescent moon",
        },
        {
          image: require("../../assets/images/3_25/home/UponWaking.svg"),
          caption:
            'Already managing <br class="d-none d-md-block">ADHD symptoms <br class="d-none d-md-block">upon waking',
          alt: "Yellow graphic of a sun",
        },
        {
          image: require("../../assets/images/3_25/home/Steady.svg"),
          caption:
            'Smooth, steady coverage <br class="d-none d-md-block">for the day ahead without a <br class="d-none d-md-block">short-acting booster*',
          alt: "Orange graphic of a scale",
        },
        {
          image: require("../../assets/images/3_25/home/ShortActingBooster.svg"),
          caption:
            'Proven ADHD symptom <br class="d-none d-md-block">support from morning<br class="d-none d-md-block"> through the afternoon<br class="d-none d-md-block"> into the early evening',
          alt: "Blue graphic of a clock",
        },
      ],
      section2Image,
      section2ImageS,
      section3Image,
      section3ImageS,
    };
  },
};
</script>

<style scoped></style>
